import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import LazyLoad from 'react-lazyload';
import LoaderAnimated from '../../abstract/loaders/loaderAnimated';

const launcherProductBadge = () => {
  const tmbProductWidgets = document.getElementsByClassName('tmb-product-widget');
  let i;
  for (i = 0; i < tmbProductWidgets.length; i++) {
    const tmbProductWidget = tmbProductWidgets[i];
    if(tmbProductWidget){
      const productId = tmbProductWidget.dataset.productid;
      const apiKey = tmbProductWidget.dataset.apikey;
      const ProductWidget = React.lazy(() => import('../../widgets/product/productWidget'));
      ReactDOM.render(
        <LazyLoad once offset={300}>
          <Suspense fallback={<LoaderAnimated animated={false} maxWidth="515px" height="193px" />}>
            <ProductWidget productId={productId} apiKey={apiKey} /> 
          </Suspense>
        </LazyLoad>
      , tmbProductWidget);
    }
  }
};

export default launcherProductBadge;